module.exports = __webpack_public_path__ + "static/media/strawberry-fruit-bar-bowl.d044d2b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/strawberry-fruit-bar-bowl.jpg
// module id = 126
// module chunks = 0